import React, { FunctionComponent } from 'react'
import { has } from 'lodash'
import { ContentfulRichTextGatsbyReference } from 'gatsby-source-contentful/rich-text'

import ArbitraryCodeEmbed from 'components/arbitraryCodeEmbed'

import { RTFBlockComponentProps, RTFBlockComponentExport } from '../../types'

import { arbitraryCodeEmbed } from './index.module.scss'

export interface RTFContentfulArbitraryEmbeddedCodeGraphQLResult
  extends ContentfulRichTextGatsbyReference {
  __typename: EF.RTFBlockTypename.ContentfulArbitraryEmbeddedCode
  fields: Contentful.ArbitraryEmbeddedCode['fields']
}

export interface ContentfulArbitraryEmbeddedCodeBlockProps
  extends RTFBlockComponentProps {
  fields: Contentful.ArbitraryEmbeddedCode['fields']
}

const ContentfulArbitraryEmbeddedCodeBlock: FunctionComponent<ContentfulArbitraryEmbeddedCodeBlockProps> = ({
  fields: {
    iframeContent: { title, relativePath, includedUrls, initialAspectRatio },
  },
}) => {
  return (
    <div className={arbitraryCodeEmbed}>
      <ArbitraryCodeEmbed
        title={title}
        src={relativePath}
        initialAspectRatio={initialAspectRatio}
        includedUrls={includedUrls}
      />
    </div>
  )
}

const componentExport: RTFBlockComponentExport = {
  component: ContentfulArbitraryEmbeddedCodeBlock,
  isValid: ({ fields }) => has(fields, 'iframeContent.relativePath'),
}

export default componentExport
